import { g as __rest, b as __assign } from '../../../../tslib.es6-fe064bda.js';
import React__default from 'react';
import { c as classnames } from '../../../../index-250ace75.js';
import '../../../../_commonjsHelpers-1a7a244d.js';

var ListItem = function (_a) {
    var children = _a.children, active = _a.active, isSelected = _a.isSelected, _b = _a.haveHover, haveHover = _b === void 0 ? true : _b, rest = __rest(_a, ["children", "active", "isSelected", "haveHover"]);
    var listItemClassNames = classnames('lists-item-row', {
        active: active,
        'is-selected': isSelected,
        'have-hover': haveHover,
    });
    return (React__default.createElement("div", __assign({ className: listItemClassNames }, rest), children));
};

export { ListItem };
